import { Button } from "@/components/ui/button";
import qrCode from "@/images/QR.png";
import heroVideo from "@/images/hero-background.mp4";
import logo104 from "@/images/104 Logo Black.png";
import { Instagram, Linkedin } from "lucide-react";

const DesktopRedirect = () => {
  return (
    <div className="min-h-screen flex bg-white">
      {/* Left Side */}
      <div className="w-1/2 flex flex-col relative h-screen">
        <div className="px-8 md:px-12 lg:px-16 pt-8 flex flex-col h-full">
          {/* Header */}
          <div className="flex justify-between items-center mb-12">
            <div className="flex items-center gap-3">
              <img src={logo104} alt="104 Logo" className="h-12 w-auto object-contain" />
              <span className="mx-2 text-lg leading-none" style={{ color: '#0B0B0D' }}>|</span>
              <span className="text-sm" style={{ color: '#565B66' }}>filmmakers in 99 minutes</span>
            </div>
            
            <div className="flex gap-4">
              <a href="https://www.instagram.com/104app" target="_blank" rel="noopener noreferrer" className="text-gray-900 hover:text-orange-600"><Instagram size={24} /></a>
              <a href="https://www.linkedin.com/company/lifeat104" target="_blank" rel="noopener noreferrer" className="text-gray-900 hover:text-orange-600"><Linkedin size={24} /></a>
            </div>
          </div>

          {/* Main Content - Centralized */}
          <div className="flex-1 flex flex-col items-center justify-center text-center max-w-md mx-auto">
            <div className="mb-8 p-4 border-2 border-gray-100 rounded-2xl shadow-sm">
              <img src={qrCode} alt="Download App QR Code" className="w-48 h-48 md:w-56 md:h-56 object-contain" />
            </div>
            
            <h1 className="text-3xl font-bold mb-4 text-gray-900">Please, Open this Page on Mobile</h1>
            <p className="text-gray-500 mb-8 leading-relaxed">
              At the moment we don't have a desktop experience for this step, to make sure you have a
              good time with us, please kindly open this page on your phone using this QR Code.
            </p>
            
            <a href="mailto:support@onezerofour.live">
              <Button variant="outline" className="h-12 px-8 rounded-xl border-gray-200 text-gray-900 font-medium">
                Contact Support for Help
              </Button>
            </a>
          </div>

          {/* Footer - At the bottom */}
          <div className="flex justify-between items-center text-xs text-gray-400 pb-5 w-full">
            <p>@2025 Ten Four Pictures | All Rights Reserved</p>
            <div className="flex gap-4">
              <a 
                href="/privacy-policy" 
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = '/privacy-policy';
                }}
                className="underline cursor-pointer"
              >
                Privacy Policy
              </a>
              <a 
                href="/terms-and-conditions" 
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = '/terms-and-conditions';
                }}
                className="underline cursor-pointer"
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - Video */}
      <div className="w-1/2 bg-white relative p-2">
        <div className="w-full h-full relative overflow-hidden rounded-[12px] bg-black">
          <video
              autoPlay
              loop
              muted
              playsInline
              className="absolute inset-0 w-full h-full object-cover"
          >
              <source src={heroVideo} type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  );
};

export default DesktopRedirect;

